// Testi comuni a tutti i moduli: menu (nav.*), login/autenticazione, profilo, errori,
// amministrazione, ecc. — tutte le chiavi che in almeno 3 moduli avevano lo stesso valore
// (tools/promote-locales.js le ha estratte dai JSON dei moduli). createLanguageEngine li
// unisce sotto il dizionario del modulo: un modulo può sempre ridefinire una chiave nel
// proprio JSON (il suo valore prevale), e ci restano solo i testi davvero suoi.
// Fonte canonica: andrea/frontend/src/i18n/kernel/{it-IT,en-GB}.json.
import itIT from './kernel/it-IT.json';
import enGB from './kernel/en-GB.json';

export const KERNEL_LOCALES = { 'it-IT': itIT, 'en-GB': enGB };
